import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { backgroundSlotsCount, productPosesCount } from '../../../imageRecords';

const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  border: 1px solid #439be2;
  border-radius: 999px;
  color: #1769aa;
  font-weight: 700;
  margin: 0 auto 18px;
  padding: 8px 14px;
  width: fit-content;
`;

const EditingIndicator = () => {
  const activeConfigSlotIndex = useSelector(
    (state: any) => state.productConfig.activeConfigSlotIndex,
  );
  const activeConfigStep = useSelector(
    (state: any) => state.productConfig.activeConfigStep,
  );
  const backgroundSelections = useSelector(
    (state: any) => state.productConfig.backgroundSelections,
  );
  const poseSelections = useSelector(
    (state: any) => state.productConfig.poseSelections,
  );
  const product = useSelector(
    (state: any) => state.productConfig.currentProduct,
  );

  const hasActiveConfigSlot =
    activeConfigSlotIndex !== null && activeConfigSlotIndex !== undefined;

  if (!hasActiveConfigSlot || !activeConfigStep) {
    return null;
  }

  const totalSlots =
    activeConfigStep === 'background'
      ? backgroundSlotsCount(product)
      : productPosesCount(product);
  const existingSelection =
    activeConfigStep === 'background'
      ? backgroundSelections[activeConfigSlotIndex]
      : poseSelections[activeConfigSlotIndex];
  const action = existingSelection ? 'Editing' : 'Selecting';
  const label = activeConfigStep === 'background' ? 'background' : 'pose';

  return (
    <Pill>{`${action} ${label} ${
      activeConfigSlotIndex + 1
    } of ${totalSlots}`}</Pill>
  );
};

export default EditingIndicator;
